import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/mentroxonehr/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/mentroxonehr/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/mentroxonehr/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/mentroxonehr/src/components/marketing/marketing.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/mentroxonehr/src/components/marketing/MarketingHeader.tsx");
